import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { BreadcrumbComponent } from "components/breadcrumb/breadcrumb.component";

@Component({
    templateUrl: './professor-filtro-visitas.component.html',
    styleUrls: ['./professor-filtro-visitas.component.scss'],
    standalone: true,
    imports:[BreadcrumbComponent, RouterLink]
})

export class PageFiltroVisitasProfessorComponent {

  constructor(

   ) {
  }


}
